import { render, staticRenderFns } from "./BtKpiForLS.vue?vue&type=template&id=9cdcbb58&scoped=true&"
import script from "./BtKpiForLS.vue?vue&type=script&lang=js&"
export * from "./BtKpiForLS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdcbb58",
  null
  
)

export default component.exports